// src/App.jsx
import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import CreateTicket from './components/CreateTicket';
import UserTickets from './components/UserTickets';
import PublicTickets from './components/PublicTickets';
import Profile from './components/Profile';
import Dashboard from './components/Dashboard';
import { Sidebar, Navbar } from './components';
import TicketDetails from './components/TicketDetails';
import EditTicket from './components/EditTicket';
import { AuthProvider } from './Context/AuthContext';
import RequireAuth from './components/RequireAuth';
import { AuthContext } from './Context/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider> {/* Wrap the app with AuthProvider */}
        <div className="relative sm:-8 p-4 bg-[#13131a] min-h-screen flex flex-row">
          <AppContent />
        </div>
      </AuthProvider>
    </Router>
  );
}

const AppContent = () => {
  const [loading, setLoading] = useState(true);
  const { token } = useContext(AuthContext); // Access user and token from context

  useEffect(() => {
    setTimeout(() => setLoading(false), 500); // Simulate loading delay
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      {token && <Sidebar />}

      <div className="flex-1 max-sm:w-full max-w-[1280px] mx-auto sm:pr-5">
        <Navbar />
        <Routes>
          {/* Redirect to Dashboard if authenticated, otherwise to SignIn */}
          <Route
            path="/"
            element={
              token ? <Navigate to="/Dashboard" replace /> : <SignIn />
            }
          />
          <Route
            path="/SignIn"
            element={token ? <Navigate to="/Dashboard" replace /> : <SignIn />}
          />
          <Route
            path="/Dashboard"
            element={<RequireAuth><Dashboard /></RequireAuth>}
          />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/create-ticket"
            element={<RequireAuth><CreateTicket /></RequireAuth>}
          />
          <Route
            path="/user-tickets"
            element={<RequireAuth><UserTickets /></RequireAuth>}
          />
          <Route
            path="/ticket-details/:id"
            element={<RequireAuth><TicketDetails /></RequireAuth>}
          />
          <Route
            path="/public-tickets"
            element={<RequireAuth><PublicTickets /></RequireAuth>}
          />
          <Route
            path="/profile"
            element={<RequireAuth><Profile /></RequireAuth>}
          />
          <Route
            path="/edit-ticket/:id"
            element={<RequireAuth><EditTicket /></RequireAuth>}
          />
        </Routes>
      </div>
    </>
  );
};

export default App;